import { DataSyncStatusSchema } from '../../shared/data-sync';
export const unlinkPersonioContract = {
    method: 'DELETE',
    path: '/api/v2/data-sync/personio',
    description: 'Unlink Personio; deletes nothing, the people, departments and teams it managed become manually maintained',
    responseSchema: DataSyncStatusSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            409: 'Conflict - a sync run is reading or applying'
        }
    }
};

//# sourceMappingURL=unlink-personio.contract.js.map